import { Grid, Theme, Typography, withStyles } from '@material-ui/core';
import { ArrowBack } from '@material-ui/icons';
import { Button, Card } from 'bc-front-sagacomponents';
import React, { useEffect } from 'react';
import { FormProvider } from 'react-hook-form';
import history from '../../../services/history';

import styles from '../style';
import ContactForm from './ContactForm';

interface Props {
  classes?: any;
  theme?: Theme;
}

const ContactPageContent = (props: Props) => {
  const { classes } = props;
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <Button
        className={classes.btnRetour}
        onClick={() => history.goBack()}
        title="Retour"
        variant="text"
        color="default"
        icon={<ArrowBack />}
      />
      <div className={classes.title}>
        <Typography variant="h2">
          <strong>Contactez-nous</strong>
        </Typography>
      </div>
      <Grid container className={classes.containerAll}>
        <Card className={classes.contentForm}>
          <ContactForm />
        </Card>
        <div className={classes.containerContact}>
          <Card className={classes.contentContact}>
            <Typography variant="h4">Par téléphone</Typography>
            <p>
              Nos équipes sont à votre disposition
              <br />
              du lundi au vendredi de 10h à 12h30 et de 14h à 17h
            </p>
            <Typography variant="h5">
              <a href="tel:0240356334">02 40 35 63 34</a>
            </Typography>
            <span className={classes.legendRed}>(appel non surtaxé)</span>
          </Card>
          <Card className={classes.contentContact}>
            <Typography variant="h4">Par courrier</Typography>
            <p>Vous pouvez nous écrire à :</p>
            <Typography variant="h5">Saga Service Plus</Typography>
            <Typography variant="h6">
              46 bis rue des Hauts Pavés
              <br />
              BP 52216
              <br />
              44022 Nantes Cedex 01
            </Typography>
          </Card>
          <Card className={classes.contentContact}>
            <Typography variant="h4">Par email</Typography>
            <Typography variant="h5">
              <a href="mailto:contact@sagaserviceplus.fr">contact@sagaserviceplus.fr</a>
            </Typography>
          </Card>
        </div>
      </Grid>
    </>
  );
};

export default withStyles(styles)(ContactPageContent);
